import React from "react";
import styled from "styled-components";
import { MatchStatusType, MatchTakerStatusType, MatchUserStatusType, useGetChattingRoomInfo } from "@src/hooks/auctionAgent/chat";

import { useChattingRoomFromContext } from "@src/contexts/ChattingRoomContext";
import { MatchServiceType } from "@src/pages/auctionAgent/chatting";
import { MatchUserType } from ".";

const MatchStatus = ({ status, userType }: { status: MatchStatusType; userType: MatchUserType }) => {
    const { chattingRoomFromContext: chattingRoomInfoFromContext } = useChattingRoomFromContext();
    const { data: chattingRoomInfo } = useGetChattingRoomInfo(
        chattingRoomInfoFromContext?.chattingRoomNo ?? 0,
        !!chattingRoomInfoFromContext?.chattingRoomNo && chattingRoomInfoFromContext?.chattingRoomNo !== 0,
    );

    const getMatchServiceTypeKor = (serviceType: MatchServiceType) => {
        if (serviceType === MatchServiceType.임장동행) {
            return "임장동행";
        }

        if (serviceType === MatchServiceType.경매대행) {
            if (chattingRoomInfo?.item.isCompleteConsulting) {
                return "매수신청대리";
            }
            return "매물컨설팅";
        }
        return MatchServiceType[serviceType];
    };

    if (!chattingRoomInfoFromContext) return null;

    if (chattingRoomInfo?.item.status && chattingRoomInfo?.item.status === MatchStatusType.매치신청) {
        return null;
    }

    return (
        <MatchStatusBox status={status}>
            {getMatchServiceTypeKor(chattingRoomInfoFromContext.serviceType)}
            &nbsp;
            {userType === "user" ? MatchUserStatusType[status] : MatchTakerStatusType[status]}
        </MatchStatusBox>
    );
};

export default MatchStatus;

const MatchStatusBox = styled.div<{ status: MatchStatusType }>`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    color: #0c002c;
    padding: 4px 8px;
    border-radius: 4px;
    border: 1px solid ${({ status }) => (status === MatchStatusType.시간만료취소 ? "#0A2540" : "#dadada")};
    width: fit-content;
    background-color: ${({ status }) => (status === MatchStatusType.시간만료취소 ? "#0A2540" : "#fff")};
    color: ${({ status }) => (status === MatchStatusType.시간만료취소 ? "#fff" : "#0A2540")};
`;
